export const mailingKeys = {
  findOne: (mailingId: string | null) => ["mailing", mailingId] as const,
};
